// import { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Tooltip } from '@mui/material';

// project import
import IconButton from 'components/@extended/IconButton';
import { ThemeMode } from 'config';

// assets
import {SettingOutlined} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router';
import { useIntl } from 'react-intl';

// ==============================|| HEADER CONTENT - SETTINGS ||============================== //

const Settings = () => {
  const theme = useTheme();
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();

  const isColumnSettings = location.pathname ==='/settings/column-settings';

  const handleToggle = () => {
    navigate(isColumnSettings ? '/archive/search' :'/settings/column-settings');
  };

  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'grey.200' : 'grey.300';
  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title={intl.formatMessage({ id: "common_settings" })}>
        <IconButton
          color="secondary"
          variant="light"
          sx={{ color: 'text.primary', bgcolor: isColumnSettings ? iconBackColorOpen : iconBackColor }}
          aria-label="open profile"
          aria-controls={isColumnSettings ? 'profile-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <SettingOutlined />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default Settings;
